<template>
    <div class="components sms-verify">
        <div class='mask'></div>
        <div class='content'
             @click="close">
            <div class='content-bind'
                 @click.stop="">
                <img class='close'
                     :src="require('@/assets/imgs/close2.png')"
                     @click="close" />
                <div class='title'>验证手机号</div>
                <div class='phone'>
                    <div>
                        <div>手机号</div>
                    </div>
                    <input class='input'
                           :style="{width:'100%'}"
                           placeholder='请输入手机号'
                           v-model="mobile" />
                </div>
                <div class='phone'>
                    <div>
                        <div>验证码</div>
                    </div>
                    <div class='flex code'>
                        <input class='input'
                               maxlength="6"
                               placeholder='请输入验证码'
                               v-model="password" />
                        <div class='yzm'
                             @click="getCode">
                            <div>{{yzm}}</div>
                        </div>
                    </div>
                </div>
                <div class="submit"
                     :class="{'sure':sure}"
                     @click="submit">
                    <div>确定</div>
                </div>
                <div class='explain'>
                    <div>验证成功后，为您查询绑定的订单</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    import { SMS_SEND, MOBILE_LOGIN } from '@/api'
    let timer = null;
    export default {
        data() {
            return {
                mobile: '',
                password: '',
                sure: false,
                yzm: '获取验证码',
                isSendCode: false,
                time: 0
            }
        },
        watch: {
            password(val) {
                if (val.length > 0 && this.mobile.length == 11 && this.mobile[0] == 1) {
                    this.sure = true;
                }
                else {
                    this.sure = false;
                }
            },
            _time(val) {
                if (val > 0) {
                    this.time = val;
                    this.yzm = `${this.time}s`;
                    timer = setInterval(() => {
                        this.time--;
                        this.yzm = `${this.time}s`;
                        if (this.time == 0) {
                            this.isSendCode = false;
                            clearInterval(timer);
                            this.yzm = '重新获取';
                        }
                    }, 1000);
                }
            }
        },
        props: ['_time', 'scene'],
        created() {
            this.$util.lockScreen();
        },
        methods: {
            close() {
                this.$util.unlockScreen();
                this.$smsVerify.close(this);
            },
            getCode() {
                if (this.mobile.length != 11 || this.mobile[0] != 1) {
                    this.$toast('您的手机号输入错误，请重新输入');
                    return;
                }
                if (this.isSendCode) {
                    return;
                }
                this.isSendCode = true;
                this.time = 60;
                timer = setInterval(() => {
                    this.time--;
                    this.yzm = `${this.time}s`;
                    if (this.time == 0) {
                        this.isSendCode = false;
                        clearInterval(timer);
                        this.yzm = '重新获取';
                    }
                }, 1000);
                this.$util.post(SMS_SEND, {
                    mobileNo: this.mobile,
                    scene: this.scene
                }).then(res => {
                    if (res.success) {
                        this.$toast('验证码已发送');
                    }
                })
            },
            submit() {
                if (!this.sure) {
                    return;
                }
                this.$smsVerify.callback({
                    success: true,
                    data: {
                        mobile: this.mobile,
                        verifyCode: this.password,
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/lib/base');
    .sms-verify {
        position: fixed;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 100;
        .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            background-color: rgba(0, 0, 0, 0.5);
        }
        .content {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            &-bind {
                .base-center;
                width: .pxToRem(660) [];
                background: rgba(255, 255, 255, 1);
                border-radius: .pxToRem(40) [];
                padding: .pxToRem(40) [] .pxToRem(50) [];
                box-sizing: border-box;
                .close {
                    position: absolute;
                    top: .pxToRem(36) [];
                    right: .pxToRem(30) [];
                    width: .pxToRem(30) [];
                    height: .pxToRem(30) [];
                }
                .title {
                    text-align: center;
                    font-size: .pxToRem(34) [];
                    font-weight: 600;
                    color: rgba(51, 51, 51, 1);
                    line-height: .pxToRem(48) [];
                }
                .phone {
                    font-size: .pxToRem(24) [];
                    color: rgba(81, 81, 81, 1);
                    line-height: .pxToRem(33) [];
                    border-bottom: 1px solid #f0f0f0;
                    margin-top: .pxToRem(40) [];
                }
                .input {
                    font-size: .pxToRem(34) [];
                    font-weight: 400;
                    color: rgba(162, 162, 162, 1);
                    line-height: .pxToRem(48) [];
                    padding: .pxToRem(30) [] 0;
                }
                .flex {
                    display: flex;
                    align-items: center;
                    position: relative;
                    &.code {
                        height: .pxToRem(108) [];
                        .input {
                            width: .pxToRem(350) [];
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: 0;
                        }
                    }
                }
                .yzm {
                    position: absolute;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: .pxToRem(163) [];
                    border-radius: .pxToRem(8) [];
                    border: .pxToRem(2) [] solid rgba(197, 172, 131, 1);
                    font-size: .pxToRem(24) [];
                    color: rgba(197, 172, 131, 1);
                    line-height: .pxToRem(33) [];
                    padding: .pxToRem(10) [] 0;
                    text-align: center;
                }
                .submit {
                    height: .pxToRem(86) [];
                    line-height: .pxToRem(86) [];
                    background: rgba(189, 190, 192, 1);
                    border-radius: .pxToRem(8) [];
                    font-size: .pxToRem(32) [];
                    color: rgba(255, 255, 255, 1);
                    text-align: center;
                    margin: .pxToRem(30) [] 0;
                }
                .sure {
                    color: black;
                    background-color: #ffdb32;
                }
                .explain {
                    text-align: center;
                    font-size: .pxToRem(24) [];
                    color: rgba(162, 162, 162, 1);
                    line-height: .pxToRem(33) [];
                }
            }
        }
    }
</style>